/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CompanyStatus } from './CompanyStatus';
import type { JobMappingMode } from './JobMappingMode';

export type Company = {
    id?: number;
    name?: string;
    code?: string;
    status?: CompanyStatus;
    isAutoPricing?: boolean | null;
    isAutoApplySpread?: boolean | null;
    aiPoweredJobRecommendations?: boolean | null;
    askBettercomp?: boolean | null;
    jobMappingMode?: JobMappingMode;
    quickSightCompany?: boolean | null;
    /**
     * Whether AMS manages this company (its ams_spa_auth_enabled flag). Its name, group and deletion are then managed in AMS, and the admin api refuses to change them. Present only when the list is called with includeAmsManaged=true.
     */
    amsManaged?: boolean;
    domain?: string | null;
    etlEnabled?: boolean;
    etlStatus?: Company.etlStatus | null;
    etlStatusAt?: string | null;
};

export namespace Company {

    export enum etlStatus {
        REPLICATING = 'replicating',
        LOADING = 'loading',
        STAGING = 'staging',
        SILVER = 'silver',
        GOLD = 'gold',
        FAILED = 'failed',
        PENDING = 'pending',
        REMOVING = 'removing',
        REMOVED = 'removed',
    }


}

